import { render, staticRenderFns } from "./coldStorageTempAnaly.vue?vue&type=template&id=1992b2a3&scoped=true"
import script from "./coldStorageTempAnaly.vue?vue&type=script&lang=js"
export * from "./coldStorageTempAnaly.vue?vue&type=script&lang=js"
import style0 from "./coldStorageTempAnaly.vue?vue&type=style&index=0&id=1992b2a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992b2a3",
  null
  
)

export default component.exports